/* eslint max-classes-per-file: 0 */
/* eslint class-methods-use-this: 0 */

import { User, UserCollection as Collection } from '@/typings/api/User'
import { Session } from '@/typings/api/Session'

import { Fabric } from '@/store/createCrudModule'
import { AgpSessionsApi, PublicationsApi } from '@/api/resources'
import { UsersAdapter } from './UsersAdapter'


interface CrudParams<P = unknown> {
  [k: string]: unknown;
  id: User['id'];
  payload: P;
}

export const fabric = Fabric<User, Collection>()

type S = UsersState
type G = UsersGetters
type M = UsersMutations
type A = UsersActions


export class UsersState extends fabric.State {
}

export class UsersGetters extends fabric.Getters<S> {
}

export class UsersMutations extends fabric.Mutations<S> {
}

export class UsersActions extends fabric.Actions<S, G, M, A> {
  protected readonly sessionsApi = new AgpSessionsApi();

  protected readonly publicationsApi = new PublicationsApi();

  protected readonly adapter = new UsersAdapter();

  protected readonly idName = 'id';

  public updateSecurity(params: CrudParams) {
    return this.adapter.api.updateSecurity(params.id, params.payload)
  }

  public updateActive(params: CrudParams) {
    return this.adapter.api.updateActive(params.payload)
  }

  public async getGroups(params: CrudParams) {
    const { data } = await this.adapter.api.getGroups(params.id, params.payload)
    return data
  }

  public async getAvailablePublications(params: CrudParams) {
    const { data } = await this.publicationsApi.getAvailablePublications(params.id)
    return data
  }

  public async getSessions(params: CrudParams) {
    const { data } = await this.adapter.api.getSessions(params.id, params.payload)
    return data
  }

  public logoutSession({ payload }: { payload: Session }) {
    return this.sessionsApi.logout(payload.id)
  }
}
